import React, { FunctionComponent } from 'react';
import '../scss/_applicationQuestionReviewItem.scss';

export const ApplicationQuestionReviewItem: FunctionComponent<{
    label: any;
    value?: any;
    showLabel?: boolean;
}> = ({ label, value = '', showLabel = true }) => {
    return (
        <div className='applicationQuestionReviewItem'>
            {showLabel && <div className='applicationQuestionReviewItem-label'>{label}</div>}
            <div className='applicationQuestionReviewItem-value'>{value}</div>
        </div>
    );
};
